module.exports = __webpack_public_path__ + "static/media/ru.c3ebfe77.svg";